export default __webpack_public_path__ + "static/media/higher_up_you_go_strapline_navy.520871bb.svg";